import { validateEmail } from 'utils'

export function normalizePaymentLinkEmails(value: string | string[] | null | undefined): string[] {
  const raw = value == null ? [] : Array.isArray(value) ? value : [`${value}`]
  const seen = new Set<string>()
  const result: string[] = []

  for (const item of raw) {
    const email = `${item || ''}`.trim().toLowerCase()
    if (!email || !validateEmail(email) || seen.has(email)) continue
    seen.add(email)
    result.push(email)
  }

  return result
}

export function defaultPaymentLinkEmails(borrowerEmail?: string, accountExecutiveEmail?: string): string[] {
  return normalizePaymentLinkEmails([borrowerEmail, accountExecutiveEmail].filter(Boolean) as string[])
}
